<div class="friendships-container">
  <div class="friendships-content">
    <div class="stats-overview" *ngIf="friends.length > 0">
      <div class="stat-card">
        <div class="stat-icon friends">
          <lucide-icon name="users" [size]="20"></lucide-icon>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ friends.length }}</div>
          <div class="stat-label">Friends</div>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon incoming">
          <lucide-icon name="mail" [size]="20"></lucide-icon>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ incomingRequests.length }}</div>
          <div class="stat-label">Incoming</div>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon outgoing">
          <lucide-icon name="send" [size]="20"></lucide-icon>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ outgoingRequests.length }}</div>
          <div class="stat-label">Sent</div>
        </div>
      </div>
    </div>

    <div class="tabs-container">
      <div class="custom-tabs">
        <button
          class="tab-button"
          [class.active]="activeTab === 'friends'"
          (click)="setActiveTab('friends')"
        >
          <span class="tab-icon"
            ><lucide-icon name="users" [size]="16"></lucide-icon
          ></span>
          <span class="tab-text">Friends</span>
          <span class="tab-badge" *ngIf="friends.length > 0">{{
            friends.length
          }}</span>
        </button>

        <button
          class="tab-button"
          [class.active]="activeTab === 'requests'"
          (click)="setActiveTab('requests')"
        >
          <span class="tab-icon"
            ><lucide-icon name="mail" [size]="16"></lucide-icon
          ></span>
          <span class="tab-text">Requests</span>
          <span
            class="tab-badge"
            *ngIf="incomingRequests.length + outgoingRequests.length > 0"
          >
            {{ incomingRequests.length + outgoingRequests.length }}
          </span>
        </button>

        <button
          class="tab-button"
          [class.active]="activeTab === 'add'"
          (click)="setActiveTab('add')"
        >
          <span class="tab-icon"
            ><lucide-icon name="user-plus" [size]="16"></lucide-icon
          ></span>
          <span class="tab-text">Add Friend</span>
        </button>
      </div>

      <div class="tab-content">
        <div class="tab-panel" *ngIf="activeTab === 'friends'">
          <div class="friends-section">
            <h2 class="section-title">Your Friends</h2>

            <div
              class="friends-grid"
              *ngIf="friends.length > 0; else noFriends"
            >
              <div
                *ngFor="let friend of friends"
                class="friend-card"
                (click)="viewProfile(friend.id)"
              >
                <div class="friend-avatar">
                  <img
                    [src]="
                      friend.profile_image ||
                      '../../assets/images/profile-pic.png'
                    "
                    [alt]="getDisplayName(friend)"
                  />
                </div>

                <div class="friend-info">
                  <div class="friend-name">{{ getDisplayName(friend) }}</div>
                  <div class="friend-username">
                    &#64;<span [textContent]="getUsername(friend)"></span>
                  </div>
                  <div class="friend-points">{{ getPoints(friend) }} PP</div>
                </div>

                <div class="friend-actions">
                  <button
                    class="action-btn invite"
                    (click)="invite(friend.id); $event.stopPropagation()"
                  >
                    <span class="btn-icon"
                      ><lucide-icon name="send" [size]="14"></lucide-icon
                    ></span>
                    <span class="btn-text">Invite</span>
                  </button>
                </div>
              </div>
            </div>

            <ng-template #noFriends>
              <div class="empty-state">
                <div class="empty-icon">
                  <lucide-icon name="users" [size]="32"></lucide-icon>
                </div>
                <h3 class="empty-title">No friends yet</h3>
                <p class="empty-text">
                  Start connecting with other padel players!
                </p>
                <button class="empty-action" (click)="setActiveTab('add')">
                  Add Your First Friend
                </button>
              </div>
            </ng-template>
          </div>
        </div>

        <div class="tab-panel" *ngIf="activeTab === 'requests'">
          <div class="requests-section">
            <div class="requests-grid">
              <div class="requests-column">
                <h3 class="column-title">
                  <span class="title-icon"
                    ><lucide-icon name="mail" [size]="16"></lucide-icon
                  ></span>
                  Incoming Requests
                  <span
                    class="title-badge"
                    *ngIf="incomingRequests.length > 0"
                    >{{ incomingRequests.length }}</span
                  >
                </h3>

                <div
                  class="requests-list"
                  *ngIf="incomingRequests.length > 0; else noIncoming"
                >
                  <div
                    *ngFor="let request of incomingRequests"
                    class="request-card incoming"
                  >
                    <div class="request-avatar">
                      <img
                        [src]="
                          request.profile.profile_image ||
                          '../../assets/images/profile-pic.png'
                        "
                        [alt]="getDisplayName(request.profile)"
                      />
                    </div>

                    <div class="request-info">
                      <div class="request-name">
                        {{ getDisplayName(request.profile) }}
                      </div>
                      <div class="request-username">
                        &#64;<span
                          [textContent]="getUsername(request.profile)"
                        ></span>
                      </div>
                    </div>

                    <div class="request-actions">
                      <button
                        class="action-btn approve"
                        (click)="
                          respondToRequest(request, friendshipStatus.Approved)
                        "
                      >
                        <span class="btn-icon"
                          ><lucide-icon name="check" [size]="14"></lucide-icon
                        ></span>
                        <span class="btn-text">Accept</span>
                      </button>
                      <button
                        class="action-btn deny"
                        (click)="
                          respondToRequest(request, friendshipStatus.Denied)
                        "
                      >
                        <span class="btn-icon"
                          ><lucide-icon name="x" [size]="14"></lucide-icon
                        ></span>
                        <span class="btn-text">Decline</span>
                      </button>
                    </div>
                  </div>
                </div>

                <ng-template #noIncoming>
                  <div class="empty-requests">
                    <div class="empty-requests-icon">
                      <lucide-icon name="mail" [size]="24"></lucide-icon>
                    </div>
                    <p class="empty-requests-text">No incoming requests</p>
                  </div>
                </ng-template>
              </div>

              <div class="requests-column">
                <h3 class="column-title">
                  <span class="title-icon"
                    ><lucide-icon name="send" [size]="16"></lucide-icon
                  ></span>
                  Sent Requests
                  <span
                    class="title-badge"
                    *ngIf="outgoingRequests.length > 0"
                    >{{ outgoingRequests.length }}</span
                  >
                </h3>

                <div
                  class="requests-list"
                  *ngIf="outgoingRequests.length > 0; else noOutgoing"
                >
                  <div
                    *ngFor="let request of outgoingRequests"
                    class="request-card outgoing"
                  >
                    <div class="request-avatar">
                      <img
                        [src]="
                          request.profile.profile_image ||
                          '../../assets/images/profile-pic.png'
                        "
                        [alt]="getDisplayName(request.profile)"
                      />
                    </div>

                    <div class="request-info">
                      <div class="request-name">
                        {{ getDisplayName(request.profile) }}
                      </div>
                      <div class="request-username">
                        &#64;<span
                          [textContent]="getUsername(request.profile)"
                        ></span>
                      </div>
                    </div>

                    <div class="request-status">
                      <span
                        class="status-badge"
                        [ngClass]="request.friendship.status.toLowerCase()"
                      >
                        {{ request.friendship.status }}
                      </span>
                    </div>
                  </div>
                </div>

                <ng-template #noOutgoing>
                  <div class="empty-requests">
                    <div class="empty-requests-icon">
                      <lucide-icon name="send" [size]="24"></lucide-icon>
                    </div>
                    <p class="empty-requests-text">No sent requests</p>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>

        <div class="tab-panel" *ngIf="activeTab === 'add'">
          <div class="add-friend-section">
            <h2 class="section-title">Add New Friend</h2>

            <div class="add-friend-card">
              <div class="add-form">
                <h3 class="form-title">
                  <lucide-icon name="search" [size]="16"></lucide-icon> Search
                  by Username
                </h3>
                <form (ngSubmit)="addFriend()" class="search-form">
                  <div class="input-group">
                    <span class="input-icon">&#64;</span>
                    <input
                      type="text"
                      [(ngModel)]="username"
                      name="username"
                      placeholder="Enter username"
                      class="username-input"
                      [disabled]="sending"
                    />
                    <button
                      type="submit"
                      class="search-btn"
                      [disabled]="sending"
                    >
                      <span class="btn-icon">
                        <lucide-icon
                          [name]="sending ? 'loader-2' : 'send'"
                          [size]="14"
                          [class.spin]="sending"
                        ></lucide-icon>
                      </span>
                      <span class="btn-text">{{
                        sending ? "Sending..." : "Send Request"
                      }}</span>
                    </button>
                  </div>
                </form>
              </div>

              <div class="share-section">
                <h3 class="form-title">
                  <lucide-icon name="share-2" [size]="16"></lucide-icon> Share
                  Your Profile
                </h3>
                <div class="share-content">
                  <div class="share-link-container">
                    <div class="input-group">
                      <span class="input-icon"
                        ><lucide-icon name="link" [size]="14"></lucide-icon
                      ></span>
                      <input
                        [value]="shareLink"
                        readonly
                        class="share-input"
                        placeholder="Your share link"
                      />
                      <button
                        type="button"
                        class="copy-btn"
                        (click)="copyLink()"
                      >
                        <span class="btn-icon"
                          ><lucide-icon name="copy" [size]="14"></lucide-icon
                        ></span>
                        <span class="btn-text">Copy</span>
                      </button>
                    </div>
                  </div>

                  <div class="qr-section" *ngIf="qrCodeUrl; else qrUnavailable">
                    <div class="qr-container">
                      <img [src]="qrCodeUrl" alt="QR Code" class="qr-image" />
                      <p class="qr-text">Scan to add as friend</p>
                    </div>
                  </div>

                  <ng-template #qrUnavailable>
                    <div class="qr-placeholder">
                      <div class="qr-placeholder-icon">
                        <lucide-icon name="qr-code" [size]="24"></lucide-icon>
                      </div>
                      <p class="qr-placeholder-text">
                        QR code will appear when available
                      </p>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="message-toast" *ngIf="message" [ngClass]="messageType">
    <span class="message-icon"
      ><lucide-icon
        [name]="messageType === 'success' ? 'circle-check' : 'circle-x'"
        [size]="16"
      ></lucide-icon
    ></span>
    <span class="message-text">{{ message }}</span>
  </div>
</div>
